import { render, staticRenderFns } from "./changelog-note.vue?vue&type=template&id=d33402a6"
import script from "./changelog-note.vue?vue&type=script&lang=js"
export * from "./changelog-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports